import { createInteractionMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { AI_AUDIO_BRIEFING_INTERACTION } from '@confluence/browser-metrics/entry-points/metric-keys';

export const AI_AUDIO_BRIEFING_INTERACTION_METRIC = createInteractionMetric({
	key: AI_AUDIO_BRIEFING_INTERACTION,
});
